module.exports = __webpack_public_path__ + "media/images/poncebattery-banner-4-71cf6c96.jpg";